/* eslint-disable */
import React, { useState } from 'react';
import { toast } from 'react-toastify';

const CeFileUpload = (props) => {
    const [filename, setFilename] = useState(null);
    const [status, setStatus] = useState('Upload Group Excel File');
    const [jid, setJid] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            uploadFile(e.target.files[0]);
        }
    };

    const uploadFile = async (file) => {
        if (!file) return;

        const cleanName = file.name.replace(/\+/g, "_");
        const renamedFile = new File([file], cleanName, {
            type: file.type,
            lastModified: file.lastModified,
        });

        setFilename(cleanName);
        setStatus('Uploading File...');


        const formData = new FormData();
        formData.append('attachment[document]', renamedFile);

        const response = await fetch('/ce_file_upload', {
            headers: { 'X-CSRF-Token': window.token },
            method: 'POST',
            body: formData
        });

        if (response.ok) {
            const data = await response.json();
            setJid(data.job_id);
            setStatus('Processing File...');
            pollStatus(data.job_id);
        } else {
            const error = await response.json();
            setStatus(`Upload failed. Try another file.`);
        }
    };

    const pollStatus = (jobId) => {
        const interval = setInterval(async () => {
            const response = await fetch(`/sidekiq_status/${jobId}`, {
                headers: {
                    'X-CSRF-Token': window.token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'GET',
            });
            const res = await response.json();

            if (res['job_data']) {
                let percentage = Number(res['job_data']['at'])

                if (percentage === 100) {
                    toast.success(`File uploaded. Upload another Group file if you have more.`)
                    setFilename(null);
                    clearInterval(interval);
                    setStatus('Upload Another Group Excel File')
                }
            } else {
                toast.error(`File failed to upload. Please try another file.`)
                clearInterval(interval);
                setFilename(null);
                setStatus('Upload failed. Try another file.');
            }
        }, 3000);
    };

    return (
        <div className="ce-file-upload-section">
            <label className='import-file-modal-btn modal-import-section ce-file-upload-btn' htmlFor='ce-file-data-upload'>
                <input id='ce-file-data-upload' type="file" onChange={handleFileChange} style={{ display: 'none' }} />
                <span>{status}</span>
            </label>
        </div>
    );
};

export default CeFileUpload;
